<template>
  <layout>
    <page-header :header="$t('settings.title')" :header-small="section.name" />
    <form ref="form" class="content settings-columns" @submit.prevent="submit">
      <div v-if="groups && Object.values(groups).length > 1" class="settings-groups-wrapper">
        <div class="settings-column">
          <b-card
            v-for="group in column1Groups"
            :key="group"
            :title="$t(group)"
          >
            <fields :group="group" />
          </b-card>
        </div>
        <div class="settings-column">
          <b-card
            v-for="group in column2Groups"
            :key="group"
            :title="$t(group)"
          >
            <fields :group="group" />
          </b-card>
        </div>
      </div>
      <b-card v-else>
        <fields />
      </b-card>
      <b-button type="submit" variant="primary">
        {{ $t('general.save') }}
      </b-button>
    </form>
  </layout>
</template>

<script>
import find from 'lodash-es/find'
import { FormMixin } from 'stylemix-base'
import { mapState } from 'vuex'

export default {
  name: 'SettingsFormBookings',

  mixins: [FormMixin],

  data: () => ({
    model: {},
    groups: {},
  }),

  computed: {
    ...mapState('settings', {
      sections: (state) => state.sections,
    }),

    section() {
      const current = find(this.sections, { key: this.$route.params.section })
      return current || {}
    },

    groupsList() {
      return Object.keys(this.groups || {})
    },

    column1Groups() {
      return this.groupsList.filter((_, i) => i % 2 === 0)
    },

    column2Groups() {
      return this.groupsList.filter((_, i) => i % 2 === 1)
    },
  },

  mounted() {
    this.loadForm()
  },

  methods: {
    loadForm() {
      this.$uiBlocker(
        this.$http
          .get(`admin-settings/sections/${this.$route.params.section}`)
          .then(({ data }) => {
            this.model = data.data.length !== undefined ? {} : data.data
            this.groups = data.groups
            this.setFields(data.fields)
          }),
        this.$refs.form
      )
    },

    submit() {
      this.$uiBlocker(
        this.$http
          .post(
            this.section?.options?.submit_url ||
              `admin-settings/sections/${this.$route.params.section}`,
            this.formData()
          )
          .then((response) => {
            this.$toast.success(response.data.message)
          }),
        this.$refs.form
      )
    },

    formData() {
      let formData = new FormData()
      this.fields.all().forEach((field) => {
        field.appendFormData(formData, this.model)
      })
      return formData
    },
  },
}
</script>

<style scoped>
.settings-groups-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

@media (min-width: 767px) {
  .settings-groups-wrapper {
    flex-direction: row;
    align-items: flex-start;
    gap: 1rem;
  }

  .settings-column {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
}
</style>
